// src/services/stabilimentiAPI.js
import apiClient from './apiClient';

const stabilimentiAPI = {
  getAllStabilimenti: (params = {}) => {
    // Construct query parameters
    const queryParams = new URLSearchParams();
    if (params.search) queryParams.append('search', params.search);
    if (params.company_id) queryParams.append('company_id', params.company_id);
    
    const queryString = queryParams.toString();
    // return apiClient.get(`/stabilimenti/index${queryString ? '?' + queryString : ''}?company_id=${localStorage.getItem('company_id')}&cantina_id=${localStorage.getItem('cantine_id')}`);
    return apiClient.get(
      `/stabilimenti/index${queryString ? '?' + queryString + '&' : '?'}company_id=${localStorage.getItem('company_id')}${localStorage.getItem('cantine_id') ? `&cantina_id=${localStorage.getItem('cantine_id')}` : ''}`
    );
    
  },
  getStabilimenti: (stabilimentoId) => apiClient.get(`/stabilimenti/show/${stabilimentoId}?company_id=${localStorage.getItem('company_id')}`),
  createStabilimenti: (stabilimentoData) => apiClient.post(`/stabilimenti/store?company_id=${localStorage.getItem('company_id')}${localStorage.getItem('cantine_id') ? `&cantina_id=${localStorage.getItem('cantine_id')}` : ''}`, stabilimentoData),
  updateStabilimenti: (stabilimentoId, stabilimentoData) => apiClient.post(`/stabilimenti/update/${stabilimentoId}?company_id=${localStorage.getItem('company_id')}${localStorage.getItem('cantine_id') ? `&cantina_id=${localStorage.getItem('cantine_id')}` : ''}`, stabilimentoData),
  deleteStabilimenti: (stabilimentoId) => apiClient.delete(`/stabilimenti/delete/${stabilimentoId}?company_id=${localStorage.getItem('company_id')}${localStorage.getItem('cantine_id') ? `&cantina_id=${localStorage.getItem('cantine_id')}` : ''}`),
  duplicateStabilimenti: (stabilimentoId) => apiClient.post(`/stabilimenti/duplicate/${stabilimentoId}?company_id=${localStorage.getItem('company_id')}`),
  
  // Enum getter
  getTipologia: () => apiClient.get(`/stabilimenti/get-tipologia?company_id=${localStorage.getItem('company_id')}`),
};

export default stabilimentiAPI;